module.exports = __webpack_public_path__ + "img/Öhm.05358a84.svg";